export const XFactionChangeDiamondSvg = ({ width }: { width: number }) => {
  return (
    <svg
      width={width}
      height={width}
      viewBox="0 0 53 53"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        y="26.3848"
        width="37.0416"
        height="37.0416"
        transform="rotate(-45 0 26.3848)"
        fill="url(#paint0_linear_297_7)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_297_7"
          x1="37.1577"
          y1="26.2687"
          x2="-1.12348"
          y2="64.5499"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6C6C6C" />
          <stop offset="0.489583" stopColor="#202020" />
          <stop offset="1" stopColor="#5B5B5B" />
        </linearGradient>
      </defs>
    </svg>
  );
};
